import React from 'react';
import Icon from '../../../components/AppIcon';
import { AuthMode } from '../types';

interface AuthTabsProps {
  activeTab: AuthMode;
  onTabChange: (tab: AuthMode) => void;
  disabled?: boolean;
}

const AuthTabs: React.FC<AuthTabsProps> = ({ activeTab, onTabChange, disabled = false }) => {
  if (activeTab === 'forgot-password' || activeTab === 'reset-password') {
    return null;
  }

  const tabs = [
    { id: 'login' as AuthMode, label: 'Autentificare', icon: 'LogIn' },
    { id: 'register' as AuthMode, label: 'Înregistrare profesor', icon: 'UserPlus' },
  ];

  return (
    <div className="flex gap-2 p-1 bg-muted rounded-lg mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabChange(tab.id)}
          disabled={disabled}
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-all duration-200 ${
            activeTab === tab.id
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground hover:bg-card/50'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          aria-current={activeTab === tab.id ? 'page' : undefined}
        >
          <Icon name={tab.icon} size={18} />
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;
